<template>
  <section class="padding-bottom-needed">
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div class="columns">
      <div class="columns">
        <div class="column is-6 is-paddingless">
          <form>
            <br>

            <h5 class="has-text-weight-bold">
              Choose your favorite options
            </h5>
            <div
              id="stepEditor"
              class="timeline"
            >
              <div class="timeline-item timeline-item-start">
                <div class="timeline-marker" />
                <div class="timeline-content">
                  <span>Due date</span>
                  <span
                    class="info"
                    style="position: relative"
                  ><span
                    class="is-warning"
                    style="width: 16px; height: 16px; border-radius: 50%; display: inline-block; position: absolute; left: -24px; top: 50%; transform: translateY(-50%);"
                  /> Mandatory steps</span>
                </div>
              </div>

              <div
                id="generatedSteps"
                ref="steps"
              >
                <div
                  v-for="(step, index) in wf.formatted_step"
                  :key="index"
                  class="timeline-item"
                >
                  <div
                    class="timeline-marker"
                    :class="[step.is_mandatory ? 'is-warning' : (step.show_details ? 'is-icon is-draggable is-info' : 'is-draggable')]"
                    style="font-family: monospace"
                  >
                    <i
                      v-if="!step.is_mandatory && step.show_details"
                      class="fas fa-arrows-v"
                      aria-hidden="true"
                    />
                  </div>
                  <div class="timeline-content">
                    <step-intro
                      :step="step"
                      :index="index"
                      :tpl_list="tpl"
                      :default_possible_choices_list="wf.default_possible_choices_list"
                      @computePeriods="computePeriods()"
                    />
                  </div>
                </div>
              </div>

              <div class="timeline-item timeline-item-end">
                <div class="timeline-marker" />
              </div>
            </div>
          </form>
        </div>
        <div class="column is-5 is-offset-1">
          <div
            class="notice-block"
            style="display: flex"
          >
            <i
              class="fas fa-question-circle fa-fw fa-2x"
              aria-hidden="true"
              style="margin-right: 1.125rem"
            />
            <div class="content">
              <p class="has-text-weight-bold">
                {{ $store.state.company.state.name }} State Compliant Workflow
              </p>
              <p>Your company is located in {{ $store.state.company.state.name }}. You must respect legal rules regarding the lien process. This workflow follows the minimum steps required by the law.</p>
              <p>You will be able to create your own customised worklow afterward.</p>
            </div>
          </div>
        </div>
        <div
          id="actionbar"
          class="actionbar-bottom has-background-white"
        >
          <div class="container is-fullhd">
            <div class="columns">
              <div class="column is-12">
                <p class="has-text-right">
                  <button
                    id="saveWorkflow"
                    class="button primary"
                    @click="saveWorkflow"
                  >
                    <span class="icon"><i
                      class="fas fa-save"
                      aria-hidden="true"
                    /></span>
                    <span>Save and continue</span>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue';
import StepEdit from './step/Workflow.vue';
import WorkflowService from '../../services/workflow.service';

const workflowService = new WorkflowService();
Vue.component('StepIntro', StepEdit);

export default {
  name: 'WorkflowIntro',
  data() {
    return {
      wf: {
        default_possible_choices_list: {},
        formatted_step: [],
        workflow: {}
      },
      tpl: {
        company: {},
        state: {}
      }
    };
  },
  mounted() {
    this.$root.showNavigation = false;

    if (document.querySelector('#actionbar')) {
      document.querySelector('.padding-bottom-needed').style.paddingBottom = `${document.querySelector('#actionbar').offsetHeight * 2}px`;
    }
    const self = this;
    this.$root.pageTitle = `Welcome ${this.$store.state.user.firstname}, let's start.`;

    workflowService.editWorkflow(this.$store.state.company.state.legal_workflow)
      .then((response) => {
        const { status, result } = response.data;

        if (status === 'success') {
          const tmp = result;
          tmp.workflow.name = `${self.$store.state.company.name} default workflow`;
          tmp.workflow.uuid = '';

          tmp.formatted_step.forEach((step) => {
            step.current_period = step.period;
          });

          self.wf = tmp;

          self.computePeriods();
        } else {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }
      })
      .catch(() => {
        self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
      });
  },
  methods: {
    computePeriods() {
      let delayFromLastMandatory = 0;
      let sumDays = 0;
      this.wf.formatted_step.forEach((step) => {
        const isMandatory = step.is_mandatory === 1;
        let currentPeriod = Math.max(0, Number(step.current_period));
        delayFromLastMandatory += currentPeriod;
        sumDays += currentPeriod;

        if (isMandatory) {
          const minDelayFromPreviousMandatory = Math.max(0, Number(step.period));

          if (minDelayFromPreviousMandatory > delayFromLastMandatory) {
            currentPeriod += (minDelayFromPreviousMandatory - delayFromLastMandatory);
            sumDays += (minDelayFromPreviousMandatory - delayFromLastMandatory);
          }
          delayFromLastMandatory = 0;
        }
        step.current_period = currentPeriod;
        step.sum_days = sumDays;
      });
    },
    saveWorkflow(event) {
      event.preventDefault();
      const data = new FormData();
      const self = this;
      data.append('formatted_steps', JSON.stringify(this.wf.formatted_step));
      data.append('name', this.wf.workflow.name);
      data.append('uuid', this.wf.workflow.uuid);

      workflowService.saveWorkflow(this.$store.state.company.uuid, data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 5000 } });
            self.$store.commit('setAccountReady', true);
            self.$router.push({ name: 'intro-template' });
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-timeline.min.css'></style>
<style scoped>
    .timeline-content {
        width: 100%;
    }

    .timeline .card {
        margin-bottom: .5em;
    }

    .columns {
        height: auto;
    }

    .is-draggable {
        cursor:ns-resize;
    }

    /*.blurred {
        opacity: .7;
        filter: blur(2px);
    }*/

    .content h4 {
        margin-bottom: 0;
    }

    .timeline .timeline-item {
        padding: 1em 0;
    }

    .timeline .timeline-item .timeline-marker {
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .timeline .timeline-item.timeline-item-start,
    .timeline .timeline-item.timeline-item-end {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
        font-size: .8em;
    }

    .timeline .timeline-item.timeline-item-start .timeline-content,
    .timeline .timeline-item.timeline-item-end .timeline-content {
        display: flex;
        justify-content: space-between;
        line-height: 1em;
    }

    .timeline .timeline-item.timeline-item-start:before,
    .timeline .timeline-item.timeline-item-end:before {
        display: none;
    }

    .timeline .timeline-item.timeline-item-start .timeline-marker {
        bottom: 0;
        top: auto;
        transform: translate(-50%, 0);
        width: 6px;
        height: 6px;
        left: 6px;
    }

    .timeline .timeline-item.timeline-item-end .timeline-marker {
        top: 0;
        bottom: auto;
        transform: translate(-50%, 0);
        width: 6px;
        height: 6px;
        left: 6px;
    }
</style>
